<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Create Scheduled Devops Action</h1>

<form #createActionForm="ngForm" novalidate>
    <!--Main Content-->
    <div *ngIf="!createDevOpsActionResponse">
        <!-- Action Name -->
        <div>
            <mat-form-field class="form-field">
                <mat-label>Select Action Name</mat-label>
                <mat-select aria-required="true" required [(ngModel)]="selectedDevOpsActionAndParameter"
                    name="actionName" (selectionChange)="onActionNameChanged()">
                    <mat-option *ngFor="let item of devOpsActionsAndParameters" [value]="item"
                        [disabled]="!item.isEnabled">
                        <span>{{item.actionName}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <!-- Customer grid -->
        <div class="ag-grid-container"
            *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Customer'">
            <p>Select Customer</p>
            <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="customerGridOptions"
                [rowData]="cloudCutomers">
            </ag-grid-angular>
            <mat-form-field class="form-field">
                <mat-label>Customer Id</mat-label>
                <input aria-required="true" required matInput [(ngModel)]="createDevOpsActionRequest.customerId"
                    name="customerId" readonly />
            </mat-form-field>
        </div>
        <!-- Account grid -->
        <div class="ag-grid-container"
            *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Account'">
            <p>Select Account</p>
            <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="accountGridOptions"
                [rowData]="cloudAccounts">
            </ag-grid-angular>
            <mat-form-field class="form-field">
                <mat-label>Account Id</mat-label>
                <input aria-required="true" required matInput [(ngModel)]="createDevOpsActionRequest.accountId"
                    name="customerId" readonly />
            </mat-form-field>
        </div>
        <!-- Environment grid -->
        <div class="ag-grid-container"
            *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Environment'">
            <p>Select Environment</p>
            <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="environmentGridOptions"
                [rowData]="cloudEnvironments">
            </ag-grid-angular>
            <mat-form-field class="form-field">
                <mat-label>Environment Id</mat-label>
                <input aria-required="true" required matInput
                    [(ngModel)]="createDevOpsActionRequest.environmentId" name="customerId" readonly />
            </mat-form-field>
        </div>
        <!-- Region -->
        <div
            *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.actionScope == 'Region'">
            <mat-form-field class="form-field">
                <mat-label>Select Region</mat-label>
                <mat-select aria-required="true" required [(ngModel)]="createDevOpsActionRequest.region"
                    name="region">
                    <mat-option *ngFor="let item of supportedRegions" [value]="item">
                        <span>{{item}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Schedule Expression OR Trigger Time-->
        <div *ngIf="selectedDevOpsActionAndParameter">
            <mat-form-field class="form-field">
                <mat-label>Trigger Type: Schedule Expression Or Trigger Time</mat-label>
                <mat-select aria-required="true" required [(ngModel)]="selectedTriggerType" name="triggerType"
                    (selectionChange)="onTriggerTypeChanged()">
                    <mat-option *ngFor="let item of triggerTypes" [value]="item">
                        <span>{{item}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <!-- Schedule Expression -->
            <div *ngIf="selectedTriggerType && selectedTriggerType == 'Schedule Expression'">
                <div>
                    <mat-form-field class="form-field">
                        <mat-label>Schedule Expression</mat-label>
                        <input aria-required="true" required matInput
                            [(ngModel)]="createDevOpsActionRequest.scheduleExpression" name="scheduleExpression"
                            (input)="onScheduleExpressionChanged()" />
                        <mat-hint>{{scheduleExpressionHint}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="schedule-div">
                    <strong>Schedule Expression Limitations:</strong>
                    <ul>
                        <li>
                            You can't specify the Day-of-month and Day-of-week fields in the same cron
                            expression.
                            If you specify a value or a * (asterisk) in one of the fields, you must use a ?
                            (question mark) in the other.
                        </li>
                        <li>
                            Cron expressions that lead to rates faster than 1 minute are not supported.
                        </li>
                        <li>
                            Only Cron expressions of length 6 is supported.
                        </li>
                    </ul>
                </div>
            </div>
            <div *ngIf="selectedTriggerType && selectedTriggerType == 'Trigger Date Time'">
                <!-- Trigger Date -->
                <mat-form-field class="form-field">
                    <mat-label>Trigger Date</mat-label>
                    <input aria-required="true" required matInput readonly [matDatepicker]="picker"
                        [(ngModel)]="selectedTriggerDate" name="triggerDate" (dateInput)="onDateChanged($event)"
                        (dateChange)="onDateChanged($event)" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <!-- Trigger Time -->
                <div>
                    <p style="color: grey; margin-bottom: 0;">Trigger Time (in 24hr)</p>
                    <div style="display: flex; flex-direction: row;">
                        <mat-form-field class="form-field-time">
                            <mat-label>Hours</mat-label>
                            <mat-select aria-required="true" required [(ngModel)]="selectedTriggerTimeHours"
                                name="triggerTimeHours" (selectionChange)="onTimeChanged()">
                                <mat-option *ngFor="let hour of hours" [value]="hour">
                                    <span>{{hour}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="form-field-time">
                            <mat-label>Minutes</mat-label>
                            <mat-select aria-required="true" required [(ngModel)]="selectedTriggerTimeMinute"
                                name="triggerTimeMinute" (selectionChange)="onTimeChanged()">
                                <mat-option *ngFor="let minute of minutes" [value]="minute">
                                    <span>{{minute}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="form-field-time">
                            <mat-label>Seconds</mat-label>
                            <mat-select aria-required="true" required [(ngModel)]="selectedTriggerTimeSecond"
                                name="triggerTimeSecond" (selectionChange)="onTimeChanged()">
                                <mat-option *ngFor="let second of seconds" [value]="second">
                                    <span>{{second}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <!-- Date Time when parsed to json with time zone information -->
                <p *ngIf="createDevOpsActionRequest?.triggerTime">Trigger Date Time in UTC:
                    {{createDevOpsActionRequest?.triggerTime | json}}</p>
            </div>
        </div>

        <!-- Parameters-->
        <div *ngIf="selectedDevOpsActionAndParameter && selectedDevOpsActionAndParameter.isParametersSupported">
            <!-- Available Named Parameters -->
            <div *ngIf="selectedDevOpsActionAndParameter.parameters">
                <mat-form-field class="form-field">
                    <mat-label>Parameters</mat-label>
                    <mat-select aria-required="true" required [(ngModel)]="selectedDevOpsParameterArray"
                        name="selectedParameter" (selectionChange)="onDevOpsParameterArrayChanged()">
                        <mat-option *ngFor="let parameter of selectedDevOpsActionAndParameter.parameters"
                            [value]="parameter.value">
                            <span>{{parameter.key}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="selectedActionParameterArray">
                <div *ngFor="let devOpsParameter of selectedActionParameterArray">
                    <section *ngIf="devOpsParameter.isBoolean">
                        <mat-checkbox [(ngModel)]="devOpsParameter.value" name="devOpsBooleanParameter">
                            {{devOpsParameter.name}}</mat-checkbox>
                    </section>
                    <mat-form-field *ngIf="devOpsParameter.isString" class="form-field">
                        <mat-label>{{devOpsParameter.name}}</mat-label>
                        <input aria-required="true" required matInput [(ngModel)]="devOpsParameter.value"
                            name="devOpsStringParameter" />
                    </mat-form-field>
                    <mat-form-field *ngIf="devOpsParameter.isNumber" class="form-field">
                        <mat-label>{{devOpsParameter.name}}</mat-label>
                        <input aria-required="true" required matInput type="number"
                            [(ngModel)]="devOpsParameter.value" name="devOpsNumberParameter" />
                    </mat-form-field>
                    <mat-form-field *ngIf="devOpsParameter.valueCollection" class="form-field">
                        <mat-label>{{devOpsParameter.name}}</mat-label>
                        <mat-select aria-required="true" required [(ngModel)]="devOpsParameter.value"
                            name="devOpsParameterSelectedCollectionValue">
                            <mat-option *ngFor="let val of devOpsParameter.valueCollection" [value]="val">
                                <span>{{val}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <button mat-raised-button (click)="addNewDevOpsActionParameter()">Add new parameter</button>
            </div>
        </div>
    </div>
    <div *ngIf="createDevOpsActionResponse">
        <span *ngIf="!createDevOpsActionResponse.error" class="check-span">
            <mat-icon>check_circle</mat-icon> Created successfully
        </span><br />
        <label>EventRule Id: {{createDevOpsActionResponse.eventRuleId}}</label> <br />
        <label *ngIf="createDevOpsActionResponse.error">Error: {{createDevOpsActionResponse.error}}</label>
        <br />
        <p><strong>Api Response:</strong></p><br />
        <p>{{createDevOpsActionResponse | json}}</p>
        <button mat-raised-button (click)="okClicked()">OK</button>
    </div>
    <div>
        <button style="margin-right: 1rem; margin-top: 1rem;" mat-raised-button color="primary" (click)="save()"
            [disabled]="createActionForm.form.invalid || isSaving || !this.selectedDevOpsActionAndParameter"
            *ngIf="!createDevOpsActionResponse">
            <span *ngIf="!isSaving">Save</span>
            <span *ngIf="isSaving">Saving...</span>
        </button>
    </div>
</form>